import { useTypedParams } from '@sorare/routing';

import { PlayerWatchlists } from 'components/player/Watchlists';

import type { PageParams } from './__generated__/routeParams';

const Watchlists = () => {
  const { slug } = useTypedParams<PageParams>();
  return <PlayerWatchlists slug={slug} />;
};

export default Watchlists;
